import { rgbColors } from '../../colors';
import type { RGBColorString } from '../../utils/rgb';
import type { NodeIconBackground, NodeIconOutline } from '../NodeStyle';
import type { NodeLabelStyle } from './NodeTypeIcon';

export const NODE_LABEL_PADDING = 2;

/**
 * Default label style = horizontally centered on top of icon with default padding
 */
export function createDefaultLabelStyle(
  nodeIconHeight: number,
): NodeLabelStyle {
  return {
    anchor: { x: 0.5, y: 1 },
    offset: { x: 0, y: -nodeIconHeight / 2 - NODE_LABEL_PADDING },
  };
}

export const nodeStyleOutlineColors: {
  [style in NodeIconOutline]: RGBColorString;
} = rgbColors;

export const nodeStyleBackgroundColors: {
  [style in NodeIconBackground]: RGBColorString;
} = rgbColors;
